var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "document-automation-request-header position-static" },
    [
      _c(
        "div",
        {
          staticClass:
            "d-flex align-items-center justify-content-start position-static",
        },
        [
          _c("h6", { staticClass: "bold mb-0" }, [
            _vm._v("\n      " + _vm._s(_vm.title) + "\n    "),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("h6", [_vm._v("\n    " + _vm._s(_vm.description) + "\n  ")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "ml-0 active-status vertical-center" },
        [
          _c(
            "button",
            {
              staticClass:
                "button-transparent edit-mode-button clickable bold text-primary",
              on: {
                click: function ($event) {
                  return _vm.$emit("toggle-edit")
                },
              },
            },
            [
              _c("span", { staticClass: "edit-mode-button-text mr-1" }, [
                _vm._v(_vm._s(_vm.editDescriptionText)),
              ]),
              _vm._v(" "),
              _c("icon", {
                staticClass: "mr-2 text-primary",
                attrs: {
                  name: _vm.isDocumentRequestEditMode ? "check" : "pencil",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "plan-tooltip",
            {
              attrs: {
                page: _vm.currentPagePlan,
                disabled: !_vm.disableActiveToggle,
              },
            },
            [
              _c("div", { staticClass: "pretty mb-2 p-switch p-fill small" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.computedActive,
                      expression: "computedActive",
                    },
                  ],
                  attrs: {
                    id: _vm.automation.id + "-toggle",
                    type: "checkbox",
                    disabled: _vm.disableActiveToggle,
                  },
                  domProps: {
                    checked: Array.isArray(_vm.computedActive)
                      ? _vm._i(_vm.computedActive, null) > -1
                      : _vm.computedActive,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.computedActive,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.computedActive = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.computedActive = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.computedActive = $$c
                      }
                    },
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "state" }, [
                  _c(
                    "label",
                    {
                      staticClass: "clickable ml-1",
                      attrs: { for: _vm.automation.id + "-toggle" },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("global.words.active")) +
                          "\n          "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }